import '../index'
import axios from 'axios'
import {
  Toast
} from 'mint-ui'

export default {
  getHomeData: function (data, callback) { //获取首页数据
    return axios.post('/web/home/index', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getExamData: function (data, callback) { //获取开放大学/自学考试/成人高考数据
    return axios.post('/web/home/getMajorParamSelect', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getCertifyData: function (data, callback) { //获取职业资格证数据
    return axios.post('/web/home/certificate/list', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getMajorList: function (data, callback) { //获取专业列表
    return axios.post('/web/home/majorList', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getCretifyProductList: function (data, callback) { //获取职业资格证产品列表
    return axios.post('/web/home/certificate/list', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getCityList: function (data, callback) { //获取城市列表
    return axios.post('/web/home/area/cityList', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getAgreement: function (data, callback) { //获取学员守则
    return axios.post('/admin/agreement/getAgreement', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getAppExportUrl: function (data, callback) { //获取APP下载路径
    return axios.post('/app/usercenter/getALLLatestVersionList', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getIosDownloadUrl:function(data, callback) { //获取IOS下载路径
    return axios.post(process.env.API_MAN + '/core/crm/user/app/getiosdownloadurl', data).then((res) => {
      // if (res) {
      //   callback(res)
      // } else {
      //   Toast('请求失败')
      // }
      callback(res)
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getLatestVersionList: function (data, callback) { //获取安卓下载路径
    return axios.post(process.env.API_MAN + '/core/crm/user/app/latestversionlist', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
  getCustomExportUrl: function (data, callback) { //获取安卓定制版下载路径
    return axios.post('/app/usercenter/getALLLatestVersionList', data).then((res) => {
      if (res) {
        callback(res)
      } else {
        Toast('请求失败')
      }
    }).catch(function (err) {
      Toast(err.msg)
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/home/home.js